import { isNative, isAndroid } from '@/lib/capacitor';

let modulePromise;

// Loads the @capacitor/haptics module *namespace* (a plain object), never the
// Haptics plugin proxy itself. Resolving a promise with the proxy makes the
// await machinery read `proxy.then`, and Capacitor's native proxy rejects any
// unimplemented property — on iOS that surfaces as
// `"Haptics.then()" is not implemented on ios` (BOSKO-FRONTEND-40).
function loadHapticsModule() {
  modulePromise ||= import('@capacitor/haptics');
  return modulePromise;
}

async function withHaptics(callback) {
  if (!isNative()) return;
  const { Haptics } = await loadHapticsModule();
  callback(Haptics);
}

export function hapticLight() {
  return withHaptics((Haptics) => {
    if (isAndroid()) {
      Haptics.vibrate({ duration: 20 });
    } else {
      Haptics.impact({ style: 'LIGHT' });
    }
  });
}

export function hapticMedium() {
  return withHaptics((Haptics) => {
    if (isAndroid()) {
      Haptics.vibrate({ duration: 40 });
    } else {
      Haptics.impact({ style: 'MEDIUM' });
    }
  });
}

export function hapticHeavy() {
  return withHaptics((Haptics) => {
    if (isAndroid()) {
      Haptics.vibrate({ duration: 60 });
    } else {
      Haptics.impact({ style: 'HEAVY' });
    }
  });
}

export function hapticSuccess() {
  return withHaptics((Haptics) => Haptics.notification({ type: 'SUCCESS' }));
}

export function hapticWarning() {
  return withHaptics((Haptics) => Haptics.notification({ type: 'WARNING' }));
}

export function hapticSelection() {
  return withHaptics((Haptics) => {
    if (isAndroid()) {
      Haptics.vibrate({ duration: 10 });
    } else {
      Haptics.selectionStart();
    }
  });
}
